import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';
import {
  type CMSApiBase,
  type CMSArrayBase,
  type CMSGroupParams,
  type CMSImageBase,
  createCmsUrl,
} from './base';

export interface VipComparisonCol extends CMSArrayBase {
  title: string;
  subTitle: string;
  levelLabel: string;
  badge: CMSImageBase;
}

export interface VipComparisonRow extends CMSArrayBase {
  label: string;
  col_1Text: string | null;
  col_1Img: CMSImageBase | null;
  col_2Text: string | null;
  col_2Img: CMSImageBase | null;
  col_3Text: string | null;
  col_3Img: CMSImageBase | null;
}

export interface VipComparisonSection extends CMSArrayBase {
  title: string;
  rows: VipComparisonRow[];
}

export interface VipBenefit extends CMSArrayBase {
  image: CMSImageBase;
  title: string;
  subTitle: string;
  description: string;
}

export interface VipFaqQuestion extends CMSArrayBase {
  question: string;
  answer: string;
}

export interface VipFaqByGroup extends CMSArrayBase, CMSGroupParams {
  items: VipFaqQuestion[];
  showGuestToggle: boolean;
}

export interface VipApi extends CMSApiBase {
  comparisonTableTitle: string;
  comparisonColsTitle: string;
  comparisonCols: VipComparisonCol[];
  comparisonSections: VipComparisonSection[];
  benefits: VipBenefit[];
  faq: VipFaqByGroup[];
}

export const getVipCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'vip',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const fetchVipCMS = async (lang: string) => {
  const response = await fetcherCMS<VipApi>(getVipCMSUrl(lang));
  return { data: response };
};
